module.exports = __webpack_public_path__ + "static/media/down-chevron.4fe969f8.svg";